import jsCookie from 'js-cookie'
import queryString from 'query-string'
import { isMiniprogram } from 'kwsdk'

let isSupportWebp = false

function supportWebp() {
  const ele = document.createElement('canvas')
  ele.width = 1
  ele.height = 1
  return (
    ele.toDataURL &&
    ele.toDataURL('image/webp').indexOf('data:image/webp') === 0
  )
}

isSupportWebp = supportWebp()

const utils = {
  getDevice() {
    const ua = navigator.userAgent
    const src = jsCookie.get('source')
    if (src === 'ios') {
      return 'ios'
    } else if (src === 'android') {
      return 'android'
    } else if (/MicroMessenger/i.test(ua)) {
      return 'weixin'
    } else if (/Mobile/i.test(ua)) {
      return 'mobile'
    }
    return 'other'
  },
  hostname(prefix = '') {
    const hn = location.hostname
    return hn.indexOf('haiziwang.com') > -1
      ? `//${prefix}.haiziwang.com`
      : `//${prefix}.cekid.com`
  },
  host(name, domain) {
    const host = domain || 'czj100'
    if (process.env.NODE_ENV === 'development') {
      return ''
    } else {
      return `//${name}.${host}.com`
    }
  },
  login(url) {
    const hostMatchPassport = utils.hostname('passport')
    const hostMatchHuodong = utils.hostname('huodong')
    const refer_url = url || location.href

    if (utils.getDevice() !== 'ios' && utils.getDevice() !== 'android') {
      location.replace(
        `${hostMatchPassport}/passport/login?referer=${encodeURIComponent(
          refer_url
        )}`
      )
    } else {
      location.href = `${hostMatchHuodong}/login?cmd=login`
    }
  },
  title(titlename) {
    try {
      try {
        document.title = titlename
        kwapp.setTitle(titlename) //eslint-disable-line
      } catch (e) {
        // eslint-disable-next-line no-undef
        kwapp.onReady(() => {
          //eslint-disable-line
          kwapp.setTitle(titlename) //eslint-disable-line
        })
      }
    } catch (e) {
      console.log(e)
    }
  },
  /**
   * @deprecated
   * 废弃
   * @param {string} url
   */
  ensureLoginWithPhone(url) {
    return new Promise((resolve, reject) => {
      const uid = jsCookie.get('uid')
      const skey = jsCookie.get('skey')
      const phone = jsCookie.get('phone')
      if (uid && skey && phone) {
        return resolve({
          uid,
          skey,
          phone
        })
      }
      reject()
      if (utils.getDevice() !== 'ios' && utils.getDevice() !== 'android') {
        console.log('please signin')
        const refer_url = url || location.href
        location.href = `${utils.hostname(
          'passport'
        )}/passport/login?referer=${encodeURIComponent(refer_url)}`
      } else {
        location.href = `${location.host}/login?cmd=login`
      }
    })
  },
  ensureLogin(url) {
    return new Promise((resolve, reject) => {
      const uid = jsCookie.get('uid')
      const skey = jsCookie.get('skey')
      // const phone = jsCookie.get('phone')
      if (uid && skey) {
        return resolve({
          uid,
          skey
          // phone,
        })
      }
      reject()
      if (utils.getDevice() !== 'ios' && utils.getDevice() !== 'android') {
        console.log('please signin')
        const refer_url = url || location.href
        location.href = `${utils.hostname(
          'passport'
        )}/passport/login?referer=${encodeURIComponent(refer_url)}`
      } else {
        location.href = `${location.host}/login?cmd=login`
      }
    })
  },
  // 基本图像处理接口
  imagePreview(value, width, height, type, viewType) {
    const view = viewType || '2'
    // value = utils.replaceHttpToHttps(value)
    let imgUrl = `${value}?imageView2/${view}`
    imgUrl = imgUrl.replace(/^http(s?):/, '')
    if (width) {
      imgUrl = `${imgUrl}/w/${width}`
    }
    if (height) {
      imgUrl = `${imgUrl}/h/${height}`
    }
    if (type) {
      imgUrl = `${imgUrl}/q/80/format/${type}`
    } else {
      imgUrl = `${imgUrl}/q/80/format/jpg`
    }
    return imgUrl
  },
  supportWebp() {
    const ele = document.createElement('canvas')
    ele.width = 1
    ele.height = 1
    return (
      ele.toDataURL &&
      ele.toDataURL('image/webp').indexOf('data:image/webp') === 0
    )
  },
  /**
   * 判断图片是否支持webp格式，并转换
   * @param {string} value
   * @param {Number} width
   * @param {Number} height
   * @param {string} type
   */
  viewImage(value, width, height, type = 'jpg', zoom = 1) {
    let img = value
    if (value) {
      // value = utils.replaceHttpToHttps(value)
      value = value.replace(/^http(s?):/, '')
      img = utils.imagePreview(
        value,
        width * zoom,
        height * zoom,
        isSupportWebp ? 'webp' : type
      )
      // if (isSupportWebp) {
      //     img = utils.imagePreview(value, width, height, 'webp')
      // } else {
      //     img = utils.imagePreview(value, width, height, type)
      // }
    }
    return img
  },
  // 图片压缩,居中裁剪
  viewImageInCenter(value, width, height, type) {
    let img = ''
    const imgType = type || 'jpg'
    if (value) {
      value = value.replace(/^http(s?):/, '')
      // value = utils.replaceHttpToHttps(value)
      if (isSupportWebp) {
        img = utils.imagePreview(value, width, height, 'webp', '1')
      } else {
        img = utils.imagePreview(value, width, height, type, '1')
      }
    }
    return img
  },
  // 头像压缩
  avatar(value, width, height, type) {
    let img = ''
    const imgType = type || 'jpg'
    if (value) {
      value = value.replace(/^http(s?):/, '')
      // value = utils.replaceHttpToHttps(value)
      if (isSupportWebp) {
        img = utils.imagePreview(value, width, height, 'webp')
      } else {
        img = utils.imagePreview(value, width, height, type)
      }
      return img
    } else {
      return require('../assets/images/avatar.png')
    }
  },
  workerAvatar(value, width, height, type) {
    let img = ''
    const imgType = type || 'jpg'
    if (value) {
      value = value.replace(/^http(s?):/, '')
      // value = utils.replaceHttpToHttps(value)
      if (isSupportWebp) {
        img = utils.imagePreview(value, width, height, 'webp')
      } else {
        img = utils.imagePreview(value, width, height, type)
      }
      return img
    } else {
      return require('../assets/images/default_headerimg.png')
    }
  },
  dateFormat(t, formater) {
    if (!t) {
      return ''
    }
    if (typeof t === 'string') {
      t = t.replace(/-/g, '/')
    }
    const time = new Date(t)
    const year = time.getFullYear()
    const month = `0${time.getMonth() + 1}`.slice(-2)
    const date = `0${time.getDate()}`.slice(-2)
    const hours = `0${time.getHours()}`.slice(-2)
    const minutes = `0${time.getMinutes()}`.slice(-2)
    const seconds = `0${time.getSeconds()}`.slice(-2)
    return formater
      .replace('YY', year)
      .replace('MM', month)
      .replace('DD', date)
      .replace('hh', hours)
      .replace('mm', minutes)
      .replace('ss', seconds)
  },
  share(config) {
    const UA = utils.getDevice()
    const conf = {
      desc: '育儿服务',
      link: location.href,
      title: '',
      imgUrl: '',
      imageByte: ''
    }
    const shareConfig = {
      ...conf,
      ...config
    }
    try {
      if (UA === 'android' || UA === 'ios') {
        window.getAppShareInfo = () => shareConfig
        window.getImInfo = () => shareConfig
      } else if (UA === 'weixin') {
        // 如果当前在微信中，取默认分享图片
        if (shareConfig.imgUrl === '') {
          // shareConfig.imgUrl = require('../assets/images/logo_share.png')
          shareConfig.imgUrl =
            'http://cmspic-10004025.image.myqcloud.com/bfce4172-b593-4fdb-ad57-d7f55ce8f869'
        }
        const reg = new RegExp('^((https|http)?://)')
        if (!reg.test(shareConfig.imgUrl)) {
          shareConfig.imgUrl = `http:${shareConfig.imgUrl}`
        }
        if (document.getElementById('weixin-share')) {
          window.wechatShare.ready(shareConfig, 1)
        } else {
          const script = document.createElement('script')
          script.setAttribute('type', 'text/javascript')
          script.setAttribute('id', 'weixin-share')
          script.setAttribute(
            'src',
            '//st.haiziwang.com/vendor/wechatShare-1.0.js'
          )
          script.async = true
          script.onload = () => {
            if (window.wechatShare) {
              window.wechatShare.ready(shareConfig, 1)
            }
          }
          script.onerror = err => {
            console.log('weixin err')
          }
          document.body.appendChild(script)
        }
      }
    } catch (e) {
      console.log(`exception：${e}`)
    }
  },
  tracker(pageId, trackType, eventID, ...params) {
    try {
      const tracker_param = utils.track_param(...params)
      // window.track._launch(页面层级id, 上报类型, 事件id, 上报参数)
      /* eslint-disable no-underscore-dangle */
      // window.track._launch(...[...args])
      window.track._launch(...[pageId, trackType, eventID, tracker_param])
    } catch (e) {
      //
    }
  },
  trackerBT(param1, param2) {
    /**
         * logType  meta 中没有时必需上报类型，默认从 <meta /> 中获取
            bizType 业务类型，默认从 <meta /> 中获取
            pageLevelId 页面ID，默认从 <meta /> 中获取
            clickId 非浏览上报时必需区块ID
            positionId 坑位编码
            positionParam 坑位内容参数
            cpm 自定义参数
            sourceId  来源编码，首次浏览上报时有效，默认从 url 中获取
            sourceParam 来源参数，首次浏览上报时有效，默认从 url 中获取
            pageParam 页面参数（需在埋点配置系统配置参数模板）
         */
    const curry = f => (a, b) => (c, d, e) => f(a, b, c, d, e)
    function upTrack(
      pageLevelId,
      clickId,
      pageParam,
      positionId,
      positionParam
    ) {
      const logType = clickId ? '20000' : '10000'
      pageParam = pageParam ? JSON.stringify(pageParam) : undefined
      positionParam = positionParam ? JSON.stringify(positionParam) : undefined
      const params = {
        pageLevelId,
        logType,
        clickId,
        pageParam,
        positionId,
        positionParam,
        bizType: '180'
      }
      Object.entries(params).forEach(item => {
        if (!item[1]) {
          delete params[item[0]]
        }
      })
      try {
        window.track && window.track._launch(params)
      } catch (e) {
        console.log(e)
      }
    }
    return curry(upTrack)(param1, param2)
  },
  track_param(...args) {
    return args.filter(ele => ele && ele !== '').join('_')
  },
  isRkhy() {
    const source = jsCookie.get('source')
    const apptype = jsCookie.get('apptype')
    return (source === 'android' || source === 'ios') && apptype === 'rkhy'
  },
  isHzwApp() {
    // app特指孩子王app，不包括人客合一
    const source = jsCookie.get('source')
    const appcode = jsCookie.get('appcode')
    return (source === 'android' || source === 'ios') && appcode === 'HZWMALL'
  },
  replaceHttpToHttps(url) {
    return url.replace('http://', 'https://')
  },
  isMp() {
    const id = jsCookie.get('miniprogramid')
    return id === 'wx38c03f55ea0ab651' || id === 'wx3fe6a0e82b10756a'
    // /*eslint-disable*/
    // return (document.cookie.match(/(?:(?:^|\s)miniprogramid\=)([^;]+)/) || [])[1] === 'wx38c03f55ea0ab651'
    //   // 最多事的商城小程序
  },
  isCzjApp() {
    const source = jsCookie.get('source')
    const key = jsCookie.get('czjkey')
    const appcode = jsCookie.get('appcode')
    return (
      (source === 'android' || source === 'ios') &&
      (appcode === 'CZJ' || key === '1')
    )
  },
  async isMiniProgramAsync() {
    if (
      jsCookie.get('miniprogramid') === 'wx38c03f55ea0ab651' ||
      jsCookie.get('miniprogramid') === 'wx3fe6a0e82b10756a'
    ) {
      return await isMiniprogram()
    } else {
      return false
    }
  },
  //是否在同城亲子小程序
  async isInLocalKidsMiniprogram() {
    if ('wxffd73aa1225d87d6' === jsCookie.get('miniprogramid')) {
      return await isMiniprogram()
    } else {
      return false
    }
  },
  allowRefreshOrShare(canRefresh, canShare) {
    try {
      window.kwapp.allowRefreshOrShare(canRefresh, canShare)
    } catch (e) {
      if (window.kwapp && window.kwapp.onReady) {
        window.kwapp.onReady(() => {
          window.kwapp.allowRefreshOrShare(canRefresh, canShare)
        })
      }
    }
  },
  // 取query
  getQueryString(name, search = location.search) {
    const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
    const val = search.substr(1).match(reg)
    if (val) {
      return decodeURIComponent(val[2])
    }
    return ''
  },
  // 适用年龄
  rangeAge(minMonth = 0, maxMonth = 0, isRecovery = false) {
    //修改显示逻辑
    // 最小月份大于等于0 且 最大月份小于等于24 数据合法 显示产后X月-X月
    // 最小月份等于-1 ||最小月份小于-2 || 最大月份大于24 不显示
    // 最小月份等于0 且 最大月份等于1200 显示 ’不限年龄‘
    /*
      if(minMonth >= 0 && maxMonth <= 24)  {
        return `产后${minMonth}月-${maxMonth}月`
      } else if(minMonth === -2 ) {
        return '不限年龄'
      } else if (minMonth === -1 || minMonth < -2 || maxMonth > 24){
        return null
      }
    */
    if (isRecovery) {
      if (minMonth >= 0 && maxMonth <= 24) {
        return `产后${minMonth}月-${maxMonth}月`
      } else if (minMonth < 0) {
        if (maxMonth > 0) {
          return `孕期-${maxMonth}月`
        } else {
          return '孕期'
        }
      } else {
        return minMonth === 0 && maxMonth === 1200 ? '不限年龄' : null
      }
    } else {
      if (minMonth === 0 && maxMonth === 1200) return '不限年龄'
      // maxMonth = Math.min(144, maxMonth)   //最大月数是144
      const s = Math.floor(minMonth / 12) // 最小岁
      const e = Math.floor(maxMonth / 12) // 最大岁
      let min = ''
      let max = ''
      let temp = ''
      if (minMonth <= -1) {
        min += '孕期'
      } else if (s < 1) {
        min += minMonth == 0 ? minMonth : minMonth + '月'
      } else {
        min += s + '岁'
      }
      temp += min
      if (e < 1) {
        if (maxMonth > 0) {
          max += maxMonth + '月'
        }
      } else {
        max += e + '岁'
      }
      if (min != max && max) {
        temp += '-'
        temp += max
      }
      return temp
    }
    /*
    const m1 = parseInt(minMonth / 12)
    const m2 = minMonth % 12
    const m3 = parseInt(maxMonth / 12)
    const m4 = maxMonth % 12

    const age1 = m1 > 0 ? m1 + '岁' + (m2 > 0 ? m2 + '月' : '') : m2 + '月'
    const age2 = m3 > 0 ? m3 + '岁' + (m4 > 0 ? m4 + '月' : '') : m4 + '月'
    if (maxMonth >= 1200) {
      return '不限年龄'
    }

    if (minMonth * 1 === 0 && maxMonth * 1 === 0) {
      return null
    } else if (minMonth * 1 < 0 && maxMonth * 1 <= 0) {
      return `孕期`
    } else if (minMonth * 1 < 0 && maxMonth * 1 > 0) {
      return '孕期-' + age2
    } else if (minMonth * 1 === 0 && maxMonth * 1 > 0) {
      return '0-' + age2
    } else {
      if (minMonth * 1 === maxMonth * 1) {
        return age1
      } else {
        return age1 + '-' + age2
      }
    }
    */
  },
  transformVh5UrlSwt(toUrl = '') {
    if (toUrl.indexOf('life.cekid.com/h5') > -1) {
      try {
        const arr = toUrl.split('?')
        const toUrlQuery = arr[1] ? arr[1] : ''
        const toUrlObj = queryString.parse(toUrlQuery)
        const locationObj = queryString.parse(location.search)
        const searchText = queryString.stringify({
          ...toUrlObj,
          swt: locationObj.swt
        })
        if (searchText) {
          return `${arr[0]}?${searchText}`
        } else {
          return toUrl
        }
      } catch (error) {
        return toUrl
      }
    } else {
      return toUrl
    }
  },
  isCzjSpu(spuType) {
    if (spuType && spuType === 402) {
      //402育儿
      return false
    }
    return true
  },
  setBaiduTrack() {
    setTimeout(() => {
      var _hmt = _hmt || []
      ;(function () {
        //百度统计 每次执行前，先移除上次插入的代码
        document.getElementById('baidu_tj') &&
          document.getElementById('baidu_tj').remove()
        var hm = document.createElement('script')
        hm.src = 'https://hm.baidu.com/hm.js?e14cf5c7ca235cccda52eb729d1fde8e'
        hm.id = 'baidu_tj'
        var s = document.getElementsByTagName('script')[0]
        s.parentNode.insertBefore(hm, s)
      })()
    }, 0)
  },
  /**
   * 将货币单位由[分]转换为[元]
   * @param cent
   * @param level
   *  - auto 小数部分为0时只返回整数部分，否则类似toFixed(2)
   *  - int 仅保留整数部分
   *  - full 类似toFixed(2)
   *  - yuan 直接除以100
   * @returns {string}
   */
  cent2yuan(cent, level = 'auto') {
    if (level === 'yuan') {
      return cent / 100
    }
    const s = cent + ''
    const y = s.substr(0, s.length - 2) // 元
    const c = s.substr(s.length - 2) // 分
    const r = c * 1 // 余数
    let ret
    if (s.length === 1) {
      ret = `0.0${s}`
    } else if (s.length === 2) {
      ret = `0.${s}`
    } else if (level === 'auto') {
      ret = `${y}${r ? '.' : ''}${r ? c : ''}`
    } else if (level === 'int') {
      ret = y
    } else if (level === 'full') {
      ret = `${y}.${c}`
    }
    // console.log(cent, level, ret)
    return ret
  },
  /**
   * 身份证号格式检查
   * @param s {String} 身份号
   * @returns {boolean}
   */
  isIdCard(s) {
    let i = 0,
      sum = 0,
      n
    for (; i < 17; i++) {
      sum += ((1 << (17 - i)) % 11) * (s[i] - '0')
    }
    n = (12 - (sum % 11)) % 11
    if (n < 10) {
      return n == s[17] - '0'
    } else {
      const t = s[17] || ''
      return t.toUpperCase() == 'X'
    }
  }
}

export default utils
